/*
 * @Author: wangshengqiang
 * @Date: 2021-04-22 15:42:04
 * @LastEditTime: 2021-06-10 16:34:58
 * @LastEditors: wangshengqiang
 * @Description: 邮箱格式
 */
import { withProps } from '@/hoc';
import { validateEmail } from '@/validator/proValidator.js';
import RowInput from '../RowInput';
export default withProps(RowInput, {
  rules: [{
    validator: validateEmail
  }]
});